$(document).ready(function() {

    //build dropdown
    $("<select />").appendTo("#navigation nav");
    
    // Create default option "Go to..."
    $("<option />", {
       "selected": "selected",
       "value"   : "",
       "text"    : "Shop..."
	}).appendTo("nav select");	
	
	// Populate dropdowns with the first menu items
	$("ul#nav li a").each(function() {
	 	var el = $(this);
	 	$("<option />", {
	     	"value"   : el.attr("href"),
	    	"text"    : el.text(),
       		"class"   : el.attr("class")
	 	}).appendTo("nav select");
	});
	
	//make responsive dropdown menu actually work			
  	$("nav select").change(function() {
    	window.location = $(this).find("option:selected").val();
  	});

	$(".fancybox").fancybox();

  	$('.flexslider').flexslider({
	animation: "fade",
    controlNav: true,
      slideshowSpeed: 1000,
	directionNav: true
  	});
    
	$('.coll-filter').customSelect();
	
   
    $('.product').hover(function(){ $(this).children('#product-info').show(); }, function(){ $(this).children('#product-info').hide(); })
 

	//<![CDATA[
	jQuery(function() {
	  jQuery('#sidebar ul li a').each(function() {
	    if (jQuery(this).attr('href')  ===  window.location.pathname) {
	      jQuery(this).addClass('current');
	    }
	  });
	});  
	//]]>
 

}); 



